import { isBrowser } from "../../../core/detection";

/**
 * Refer to lazysizes JS API for full list of configuration options
 * [https://github.com/aFarkas/lazysizes#js-api---options]
 */
const lazySizesConfig = {
  loadHidden: false,
};

if (isBrowser()) {
  window.lazySizes.cfg = { ...window.lazySizes.cfg, ...lazySizesConfig };
}

export type LazySizesConfig = typeof lazySizesConfig;
